import { CHECKOUT_MENU_ITEM } from '../constants/checkoutMenuItem';
import { CLIENTS_MENU_ITEM, ORDERS_MENU_ITEM } from '../constants/mainMenuItem';
import { PRODUCTS_MENU_ITEM } from '../constants/productsMenuItem';
import {
    ABOUT_MENU_ITEM,
    EMAIL_NOTIFICATIONS_MENU_ITEM,
    LOGISTICS_MENU_ITEM,
    MANAGERS_MENU_ITEM,
    OTHER_MENU_ITEM,
    PAYMENT_MENU_ITEM,
    PRODUCT_FEED_MENU_ITEM,
    SETTINGS_ROOT_MENU_ITEM,
    YA_METRIKA_MENU_ITEM,
    YCP_MENU_ITEM,
} from '../constants/settingsMenuItem';
import { type MenuConfiguration, type MenuSection, type SidebarMenuItem } from '../types';

const YCP_MAIN_MENU_SECTION: MenuSection = [ORDERS_MENU_ITEM, PRODUCTS_MENU_ITEM, CLIENTS_MENU_ITEM];

const YCP_SETTINGS_MENU_SECTION: MenuSection = [SETTINGS_ROOT_MENU_ITEM, CHECKOUT_MENU_ITEM];

const YCP_SETTINGS_MENU_ITEMS: SidebarMenuItem[] = [
    ABOUT_MENU_ITEM,
    MANAGERS_MENU_ITEM,
    YCP_MENU_ITEM,
    PRODUCT_FEED_MENU_ITEM,
    LOGISTICS_MENU_ITEM,
    PAYMENT_MENU_ITEM,
    EMAIL_NOTIFICATIONS_MENU_ITEM,
    YA_METRIKA_MENU_ITEM,
    OTHER_MENU_ITEM,
];

export const YCP_MENU_CONFIGURATION: MenuConfiguration = {
    sidebarSections: [YCP_MAIN_MENU_SECTION, YCP_SETTINGS_MENU_SECTION],
    settingsMenuItems: YCP_SETTINGS_MENU_ITEMS,
};
